import { useMediaQuery } from "react-responsive";

/**
 * The types of a Events
 * Size names from: https://github.com/ant-design/ant-design/blob/master/components/style/themes/default.less
 * @enum {string}
 */
export const SCREEN_SIZE_TYPES = {
  XXS: "small_phone",
  XS: "phone",
  SM: "tablet",
  MD: "desktop",
  LG: "wide_desktop",
  XL: "full_hd",
  XXL: "large_desktop",
};

/**
 * @param {SCREEN_SIZE_TYPES} screenSize
 * @param {SCREEN_SIZE_TYPES} comparator
 */
export function isScreenSizeGreaterThan(screenSize, comparator) {
  const sortedScreenSizeTypes = Object.values(SCREEN_SIZE_TYPES);
  const screenSizeIndex = sortedScreenSizeTypes.indexOf(screenSize);
  const comparatorIndex = sortedScreenSizeTypes.indexOf(comparator);
  if (!screenSizeIndex || !comparatorIndex) return undefined;
  return screenSizeIndex > comparatorIndex;
}

/**
 * @returns {SCREEN_SIZE_TYPES}
 */
export default function useScreenSize() {
  // Default sizes from Ant: https://github.com/ant-design/ant-design/blob/master/components/style/themes/default.less
  const mediaQueries = [
    {
      label: SCREEN_SIZE_TYPES.XS,
      value: useMediaQuery({ query: "(min-width: 480px)" }),
    },
    {
      label: SCREEN_SIZE_TYPES.SM,
      value: useMediaQuery({ query: "(min-width: 576px)" }),
    },
    {
      label: SCREEN_SIZE_TYPES.MD,
      value: useMediaQuery({ query: "(min-width: 768px)" }),
    },
    {
      label: SCREEN_SIZE_TYPES.LG,
      value: useMediaQuery({ query: "(min-width: 992px)" }),
    },
    {
      label: SCREEN_SIZE_TYPES.XL,
      value: useMediaQuery({ query: "(min-width: 1200px)" }),
    },
    {
      label: SCREEN_SIZE_TYPES.XXL,
      value: useMediaQuery({ query: "(min-width: 1600px)" }),
    },
  ];

  // Find the last one that is true, meaning the first one from the end that's true
  const sizeLabel = [...mediaQueries]
    .reverse()
    .find(({ value }) => value === true)?.label;

  if (!sizeLabel) {
    return SCREEN_SIZE_TYPES.XXS;
  }

  return sizeLabel;
}
